import { render, staticRenderFns } from "./PriceOnRequest.vue?vue&type=template&id=325eaf6f&"
import script from "./PriceOnRequest.vue?vue&type=script&lang=js&"
export * from "./PriceOnRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports